import { activityFetch as fetch } from './components/feedback/requestActivity'
function objectToQueryString(obj) {
    return Object.keys(obj)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        .join('&');
}

// 빈 응답에도 안전하게 JSON 파싱
function safeJson(res) {
    return res.text().then(t => {
        if (!t) return null;
        try { return JSON.parse(t); }
        catch (e) {
            console.error('JSON 파싱 실패:', t.slice(0, 200));
            return null;
        }
    });
}

function reqPost(uri,param,callback,onError){
        return fetch(uri, {
          method: 'POST',
          mode:'cors',
          credentials:'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(param)
        }).then((res) => {
            if (!res.ok) {
              throw new Error(`Server responded with status code ${res.status}`);
            }
            return safeJson(res);
         }).then((msg) => {
            if(callback) callback(uri);
            return msg;
        })
         .catch(err => { if (onError) onError(err); else alert('요청을 처리하지 못했습니다: ' + err.message); });
}

function reqGet(uri, param, callback) {
    const queryString = objectToQueryString(param);
    // uri 에 이미 ? 가 있으면 & 로 추가, queryString 비어있으면 그대로
    const sep = uri.includes('?') ? '&' : '?';
    const fullUri = queryString ? `${uri}${sep}${queryString}` : uri;
    fetch(fullUri, { credentials: 'include' })
    .then((res) => {
        if (!res.ok) {
          throw new Error(`Server responded with status code ${res.status}`);
        }
        return safeJson(res);
     }).then((msg) => {
            if(callback) callback(msg ?? [], param);
        })
        .catch(err => {
            console.error(`[reqGet] ${fullUri} 실패:`, err);
            alert('Error: ' + (err.message || err));
        });
}
export { reqPost, reqGet };
